import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { useMsal } from '@azure/msal-react';
import useSensorStore from '../store/sensorStore';
import { errorHandler } from '../utils/helpers';
import { msalConfig } from '../auth/authConfig';
import { acquireToken } from '../utils/auth';

interface FetchData {
  token: string | null;
  updateSensorStatuses: (data: any) => any;
  setError: (data: any) => any;
  setLoading: (data: any) => any;
};

const fetchData = async ({
    token,
    updateSensorStatuses,
    setError,
    setLoading,
  }: FetchData) => {
  try {
    const response = await axios.get(`${window.__env.REACT_APP_API_URL || process.env.REACT_APP_API_URL}/Sensor/Status`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json, text/plain, */*',
      },
    });
    const statuses = response.data;
    updateSensorStatuses(statuses);
  } catch (error) {
    errorHandler(error, setError);
  } finally {
    setLoading(false);
  }
};

interface FetchSensorStatuses {
  fetchSensorsStatuses: () => void;
  loading: boolean;
  error: Error | null;
};

const useFetchSensorStatuses = (): FetchSensorStatuses => {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const { updateSensorStatuses } = useSensorStore();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchSensorsStatuses = async () => {
    if (accounts.length > 0) {
      const accessTokenRequest = {
        scopes: [`${msalConfig.auth.clientId}/.default`],
        account: accounts[0],
      };
      try {
        const accessToken = await acquireToken(instance, accessTokenRequest);
        fetchData({
          token: accessToken,
          updateSensorStatuses,
          setError,
          setLoading,
        });
      } catch (error) {
        errorHandler(error, setError);
      }
    } else {
      navigate('/sign-in');
    }
  }

  return { fetchSensorsStatuses, loading, error };
};

export default useFetchSensorStatuses;
